import { Navigate } from 'react-router-dom';
import { Globle_app_context } from '../context/globle_context';
import { useContext } from 'react';

export default function PrivateRoute({ children }) {
  const { Auth_status } = useContext(Globle_app_context);
  console.log(Auth_status);
  if (Auth_status) {
    return children;
  } else {
    return <Navigate to="/signin" />;
  }
}
